import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

export interface IEventsPageText {
  RecentText: string;
  OldestText: string;
}

export interface ICountdownText {
  CountdownText: string;
  DaysText: string;
  HoursText: string;
  MinutesText: string;
  SecondsText: string;
}

interface IEventsPageDataResult {
  fetch: {
    Common: {
      Events: {
        BackgroundColor: string | null;
        HeaderColor: string | null;
      } | null;
    };
    Country: {
      HomePage: {
        Splash: {
          Countdown: ICountdownText | null;
        } | null;
      };
      EventsPage: IEventsPageText & {
        Header: string;
      };
    };
  };
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

interface IRequiredProps {
  country: string;
}

export type WithEventsPageQueryProps = QueryResult<IEventsPageDataResult>;

class EventsPageQuery extends Query<IEventsPageDataResult, IVariables> {}

const withEventsPageQuery = <P extends WithEventsPageQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, WithEventsPageQueryProps> & IRequiredProps
> => props => {
  const { country } = props;
  return (
    <EventsPageQuery
      query={queries.GET_EVENTS_PAGE_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </EventsPageQuery>
  );
};

export default withEventsPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withEventsPageQuery.tsx